<template>
  <div class="page-home">
    <div class="home-header-desktop">
      <div class="header-logo">
        <img src="@/assets/images/layouts/logo_white.png" alt="" />
        <span>THE ATK PLAYER</span>
      </div>
      <div class="header-action" @click="$router.push('/client/products')">
        <span v-show="!userInfo.email">SIGN IN</span>
        <span v-show="userInfo.email">ADMIN</span>
      </div>
    </div>
    <div class="home-header-mobile">
      <div class="header-mobile-container">
        <div class="header-logo">
          <img src="@/assets/images/layouts/logo_white.png" alt="" />
        </div>
        <div class="header-title">
          <span>THE ATK PLAYER</span>
        </div>
      </div>
    </div>
    <div class="home-head">
      <div class="head-title">
        <span>Your showroom </span>
        <br class="mobile-br" />
        <span>in their pocket.</span>
      </div>
      <div class="head-content">
        <div class="img-mics-desktop">
          <img src="@/assets/images/users/home/head_mics_desktop.png" alt="" />
        </div>
        <div class="img-mics-mobile">
          <img src="@/assets/images/users/home/head_mics_mobile.png" alt="" />
        </div>
        <div class="img-iphone" @click="launchPlayer">
          <img src="@/assets/images/users/home/head_iphone.png" alt="" />
        </div>
        <div class="head-actions">
          <div class="action-lanuch" @click="launchPlayer">
            <button type="button">LAUNCH PLAYER</button>
          </div>
          <div class="action-learn">
            <a href="mailto:atkplayer@audiotestkitchen.com">
              <button type="button">LEARN HOW</button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="home-desc">
      <div class="desc-title">
        <span>Seamlessly integrates with your website.</span>
      </div>
      <div class="desc-lanuch" @click="launchPlayer">
        <button type="button">LAUNCH PLAYER</button>
      </div>
      <div class="desc-just">
        <img class="just-desktop" src="@/assets/images/users/home/just_like_desktop.png" alt="" />
        <img class="just-mobile" src="@/assets/images/users/home/just_like_mobile.png" alt="" />
      </div>
      <div class="desc-infos">
        <div class="infos-line">
          <span>Make it easy for your customers</span>
        </div>
        <div class="infos-line">
          <span>to compare your products</span>
        </div>
        <div class="infos-line">
          <span>and hear their sound.</span>
        </div>
      </div>
    </div>
    <div class="home-brands">
      <div class="brands-title">
        <span>Trusted by 65 pro audio brands, and counting.</span>
      </div>
      <div class="brands-logos">
        <div class="logos-desktop">
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_desktop_1.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_desktop_2.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_desktop_3.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_desktop_4.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_desktop_5.png" alt="" />
          </div>
        </div>
        <div class="logos-mobile">
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_mobile_1.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_mobile_2.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_mobile_3.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_mobile_4.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_mobile_5.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_mobile_6.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_mobile_7.png" alt="" />
          </div>
          <div class="logos-line line-right">
            <img src="@/assets/images/users/home/logos_mobile_8.png" alt="" />
          </div>
          <div class="logos-line line-left">
            <img src="@/assets/images/users/home/logos_mobile_9.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="home-learn">
      <div class="learn-desc learn-internet">
        <div class="learn-line">
          <span>Don’t leave the Internet</span>
        </div>
        <div class="learn-line">
          <span>in charge of</span>
        </div>
        <div class="learn-line">
          <span>your product experience.</span>
        </div>
      </div>
      <div class="learn-desc">
        <div class="learn-line">
          <span>Make product choice</span>
        </div>
        <div class="learn-line">
          <span>clear and delightful</span>
        </div>
        <div class="learn-line">
          <span>for your customer.</span>
        </div>
      </div>
      <div class="action-learn">
        <a href="mailto:atkplayer@audiotestkitchen.com">
          <button type="button">LEARN HOW</button>
        </a>
      </div>
    </div>
    <div class="home-atk">
      <span>THE ATK PLAYER</span>
    </div>
    <div class="home-footer">
      <div class="footer-contact">
        <a href="mailto:sales@audiotestkitchen.com">
          <span>Contact Sales</span>
        </a>
      </div>
      <div class="footer-logo">
        <img src="@/assets/images/layouts/logo_white_text.png" alt="" />
      </div>
      <div class="footer-copyright">
        <span>©{{ currentYear }} Audio Test Kitchen. All Rights Reserved</span>
      </div>
    </div>
    <atk-player />
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    'atk-player': 'atk-player'
  },
  data () {
    return {
      userInfo: {},
      instanceId: '',
      currentYear: new Date().getFullYear()
    }
  },
  created () {
    this.getLanding()
    this.getUserInfo()
  },
  computed: {
  },
  methods: {
    getUserInfo: function () {
      const that = this
      this.$service.get('/api/v1/atk_player/users/info').then(function (res) {
        if (res.code === 200) {
          that.userInfo = res.data
        } else {
          console.error('getUserInfo', res)
        }
      }).catch(function (err) {
        console.error('getUserInfo', err)
      })
    },
    getLanding: function () {
      const url = '/api/v1/atk_player/widget/settings/landing_instance'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          if (res.data.content.instance) {
            that.instanceId = res.data.content.instance._id
          }
        } else {
          console.error('getLanding', res.msg)
        }
      }).catch(function (err) {
        console.error('getLanding', err.msg)
      })
    },
    launchPlayer: function () {
      document.querySelector('atk-player').params = { instance: this.instanceId, status: 'show' }
    }
  }
}
</script>

<style scoped lang="scss">
.page-home {
  padding-top: 40px;
  .home-header-desktop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    background-color: #3B4D5D;
    height: 40px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-logo {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 35px;
      }
      span {
        margin-left: 6px;
        color: #A5C2CB;
        font-size: 28px;
        font-weight: bold;
        letter-spacing: -1px;
      }
    }
    .header-action {
      color: white;
      cursor: pointer;
      font-size: 13px;
    }
  }
  .home-header-mobile {
    display: none;
  }
  .home-head {
    position: relative;
    .head-title {
      font-size: 40px;
      text-align: center;
      margin: 37px auto 57px;
      .mobile-br {
        display: none;
      }
    }
    .head-content {
      display: flex;
      .img-mics-desktop {
        width: 450px;
        img {
          width: 100%;
        }
      }
      .img-mics-mobile {
        display: none;
      }
      .img-iphone {
        margin-left: 30px;
        width: 540px;
        height: 590px;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      .head-actions {
        height: 470px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 45px 0 0 -100px;
        button {
          border: none 0;
          padding: 0;
          width: 200px;
          height: 56px;
          line-height: 56px;
          font-size: 21px;
          border-radius: 6px;
          cursor: pointer;
        }
        .action-lanuch {
          button {
            background-color: #17C4EE;
            color: white;
          }
        }
        .action-learn {
          button {
            background-color: #E0E0E0;
            color: black;
          }
        }
      }
    }
  }
  .home-desc {
    padding: 125px 0 70px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.99) 0%, #FFE075 100%);
    text-align: center;
    .desc-title {
      font-size: 38px;
      margin-bottom: 80px;
    }
    .desc-lanuch {
      button {
        border: solid 1px black;
        padding: 0;
        width: 200px;
        height: 56px;
        line-height: 54px;
        font-size: 21px;
        border-radius: 6px;
        cursor: pointer;
        color: black;
        background: transparent;
      }
    }
    .desc-just {
      margin: -40px 0 0 128px;
      width: 365px;
      img {
        width: 100%;
        &.just-mobile {
          display: none;
        }
      }
    }
    .desc-infos {
      margin-top: 160px;
      font-size: 38px;
      .infos-line {
      }
    }
  }
  .home-brands {
    background-color: #223040;
    padding: 130px 0;
    .brands-title {
      font-size: 42px;
      text-align: center;
      color: white;
      margin-bottom: 100px;
    }
    .logos-mobile {
      display: none;
    }
    .brands-logos {
      .logos-line {
        overflow: hidden;
        img {
          width: 200%;
        }
        &.line-left {
          img {
            padding-left: 38px;
            float: left;
          }
        }
        &.line-right {
          img {
            padding-right: 38px;
            float: right;
          }
        }
      }
    }
  }
  .home-learn {
    padding: 180px 0;
    text-align: center;
    .learn-desc {
      font-size: 38px;
      &.learn-internet {
        margin-bottom: 156px;
      }
    }
    .action-learn {
      margin-top: 42px;
      button {
        border: none 0;
        padding: 0;
        width: 200px;
        height: 56px;
        line-height: 56px;
        font-size: 21px;
        border-radius: 6px;
        cursor: pointer;
        background-color: #E0E0E0;
        color: black;
      }
    }
  }
  .home-atk {
    color: #A5C2CB;
    text-align: center;
    font-size: 60px;
    font-weight: bold;
    letter-spacing: -2px;
  }
  .home-footer {
    background-color: #8BACB4;
    color: white;
    text-align: center;
    padding: 20px 0;
    .footer-contact {
      font-size: 19px;
      a {
        color: white;
        text-decoration: none;
      }
    }
    .footer-logo {
      width: 180px;
      margin: auto;
      img {
        width: 100%;
      }
    }
    .footer-copyright {
      font-size: 14px;
    }
  }
}
@media (max-width: 768px) {
  .page-home {
    padding-top: 56px;
    .home-header-desktop {
      display: none;
    }
    .home-header-mobile {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      display: block;
      background-color: #3B4D5D;
      height: 56px;
      line-height: 56px;
      text-align: center;
      .header-mobile-container {
        position: relative;
      }
      .header-logo {
        position: absolute;
        top: 8px;
        left: 8px;
        width: 40px;
        img {
          width: 100%;
        }
      }
      .header-title {
        font-size: 23px;
        font-weight: bold;
        letter-spacing: -1px;
        color: white;
      }
    }
    .home-head {
      .head-title {
        font-size: 30px;
        line-height: 36px;
        margin: 22px auto 64px;
        .mobile-br {
          display: block;
        }
      }
      .head-content {
        position: relative;
        justify-content: space-between;
        .img-mics-desktop {
          display: none;
        }
        .img-mics-mobile {
          display: block;
          width: 172px;
        }
        .img-iphone {
          width: 210px;
          height: 462px;
          margin: 18px 0 0 0;
          img {
            width: auto;
            height: 100%;
          }
        }
        .head-actions {
          position: absolute;
          top: -44px;
          left: 0;
          width: 100%;
          height: 450px;
          margin: 0;
          text-align: center;
          button {
            width: 165px;
            height: 45px;
            line-height: 45px;
            font-size: 17px;
          }
        }
      }
    }
    .home-desc {
      padding: 116px 0;
      .desc-title {
        font-size: 31px;
        margin-bottom: 40px;
      }
      .desc-lanuch {
        button {
          width: 165px;
          height: 45px;
          line-height: 43px;
          font-size: 17px;
        }
      }
      .desc-just {
        margin: 20px auto 0;
        width: 245px;
        img {
          width: 100%;
          &.just-desktop {
            display: none;
          }
          &.just-mobile {
            display: block;
          }
        }
      }
      .desc-infos {
        margin-top: 80px;
        font-size: 27px;
        .infos-line {
        }
      }
    }
    .home-brands {
      padding: 60px 0;
      .brands-title {
        font-size: 30px;
        margin-bottom: 60px;
      }
      .logos-desktop {
        display: none;
      }
      .logos-mobile {
        display: block;
      }
      .brands-logos {
        .logos-line {
          &.line-left {
            img {
              padding-left: 10px;
            }
          }
          &.line-right {
            img {
              padding-right: 10px;
            }
          }
        }
      }
    }
    .home-learn {
      .learn-desc {
        font-size: 27px;
        &.learn-internet {
        }
      }
      .action-learn {
        margin-top: 30px;
        button {
          width: 165px;
          height: 45px;
          line-height: 45px;
          font-size: 17px;
        }
      }
    }
    .home-atk {
      font-size: 40px;
    }
    .home-footer {
      padding: 30px 0;
      .footer-contact {
        font-size: 20px;
        a {
        }
      }
      .footer-logo {
        width: 200px;
        margin: 20px auto 35px;
        img {
        }
      }
      .footer-copyright {
        font-size: 16px;
      }
    }
  }
}
</style>
